/* global $ */
/**
 * Facebook Pixel Adapter for Analytics System
 * This is needed in the case that the Facebook Pixel gets blocked by AdBlockers
 * This doesn't provide as much data as the pixel method, so this is a fallback
 * It doesn't hurt to have both
 */

class FacebookConversionsAdapter {
  /**
   * This is adaptable for the environment to ensure proper testing
   * For example, on prod, it's https://api.gosearch.ai/sadc
   * On dev, it's https://dev01.gosearch.ai/d/branch/sean/d/api/sadc.php
   * On Dockup it's https://dockup.gosearch.ai/dockup/3008/d/api/sadc.php
   */
  static get API_ENDPOINT() {
    // Use SearchConfig from window if available, fallback to hardcoded values for backward compatibility
    if (window?.SearchConfig) {
      const { HTTP_HOST, ROOT_PATH, ENV } = window.SearchConfig;
      if (ENV === 'DEV' || ENV === 'LOCAL') {
        return `${ROOT_PATH}d/api/sadc.php`;
      }
      return `https://${HTTP_HOST}${ROOT_PATH}d/api/sadc.php`;
    }

    // Fallback to original logic if SearchConfig is not available
    return process.env.NODE_ENV === 'development' ? '/d/api/sadc.php' : 'https://api.gosearch.ai/sadc';
  }

  /**
   * Track an event to Facebook Pixel
   * @param {string} eventName - Event title/name
   */
  static track(eventName) {
    try {
      // Prepare data object for the API call
      const data = {
        event: eventName,
        dl: window.location.href, // Current page URL
      };

      // Add email if available in eventProperties
      if (window.GoSearch?.email) {
        data.em = window.btoa(window.GoSearch?.email);
      }

      // Try to get fbclid from URL parameters
      try {
        const params = new URLSearchParams(document.location.search);
        const gfid = params.get('fbclid');
        if (gfid) {
          data.gfid = gfid;
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Failed to get fbclid from URL parameters');
        }
      }

      // Send the data to the GoSearch API endpoint
      $.ajax({
        url: this.API_ENDPOINT,
        dataType: 'json',
        data,
      });
    } catch (error) {
      // Fail silently - don't break user experience
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Facebook Conversions tracking error:', error);
      }
    }
  }

  /**
   * Identify a user (Facebook Pixel doesn't have traditional identify,
   * but we can use this for advanced matching if needed)
   * @param {Object} userProperties - User data
   */
  static identify(userProperties = {}) {
    try {
      if (userProperties.email || userProperties.user_id) {
        // Use fbq init function for user identification with advanced matching
        // the facebook pixel handles hashing of the email
        // the external_id is the user_id from the database
        // Send the data to the GoSearch API endpoint
        const data = {
          em: window.btoa(userProperties.email),
          dl: window.location.href,
        };

        try {
          const params = new URLSearchParams(document.location.search);
          const gfid = params.get('fbclid');
          if (gfid) {
            data.gfid = gfid;
          }
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('Failed to get fbclid from URL parameters');
          }
        }

        $.ajax({
          url: this.API_ENDPOINT,
          dataType: 'json',
          data,
        });
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn('Facebook Conversions identify error:', error);
      }
    }
  }
}

export default FacebookConversionsAdapter;
